module.exports = "/_next/static/images/hawaii-951aab64832c0fb3c2293bce5b79b357.svg";